import { ArrowDown, ArrowUp, MagnifyingGlass, X } from 'phosphor-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, InputAdornment, TextField, useMediaQuery, useTheme } from '@mui/material';

interface LibrarySearchControlsProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  sortOrder: 'name' | '-name';
  toggleSortOrder: () => void;
}

export const LibrarySearchControls: React.FC<LibrarySearchControlsProps> = ({
  searchQuery,
  setSearchQuery,
  sortOrder,
  toggleSortOrder,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        width: isMobile ? '100%' : 'auto',
      }}
    >
      <TextField
        placeholder={t('Search courses...')}
        variant="outlined"
        size="small"
        value={searchQuery}
        onChange={handleSearchChange}
        aria-label={t('Search courses')}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <MagnifyingGlass size={20} />
            </InputAdornment>
          ),
          endAdornment: searchQuery ? (
            <InputAdornment position="end">
              <Button size="small" onClick={() => setSearchQuery('')} sx={{ minWidth: 'auto', p: 0.5 }}>
                <X size={16} />
              </Button>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          width: isMobile ? '100%' : 250,
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
          },
        }}
      />

      <Button
        variant="outlined"
        startIcon={sortOrder === 'name' ? <ArrowUp size={18} /> : <ArrowDown size={18} />}
        onClick={toggleSortOrder}
        sx={{
          minWidth: 120,
          textTransform: 'none',
          borderRadius: '10px',
        }}
      >
        {sortOrder === 'name' ? 'A-Z' : 'Z-A'}
      </Button>
    </Box>
  );
};